/**
 * @Description
 */

import { isArray, isNotEmptyAny } from '@lhb/func';
import { ControlType, parseValueCatch } from '../../../config';

export const handleJNPValue = (item: any, form: any) => {
  if (item.controlType !== ControlType.PROFIT_CAlCULATION_JNP.value) return;

  const val = parseValueCatch(item);
  // console.log('handleJNPValue');
  if (!isNotEmptyAny(val)) return;

  const {
    saleTarget,
    operatingIncome,
    costExpense,
    employeeCompensationCost,
    storeImageCost,
    storeEngineeringCost,
    leaseCost,
    otherCost,
  } = val || {};

  const values = {
    saleTarget: getYearDataArray(saleTarget),
    operatingIncome: getYearDataArray(operatingIncome),
    costExpense: getYearDataArray(costExpense),
    employeeCompensationCost: getYearDataArray(employeeCompensationCost),
    storeImageCost: storeImageCost.data,
    storeEngineeringCost: storeEngineeringCost.data,
    leaseCost: getYearDataArray(leaseCost),
    otherCost: getYearDataArray(otherCost),
  };
  form.setFieldValue(item.identification, values);
};

const getYearDataArray = (moduleData: any) => {
  const firstYear = isArray(moduleData?.yearData) && moduleData?.yearData.length === 2 ? moduleData?.yearData[0] : {};
  const secondYear = isArray(moduleData?.yearData) && moduleData?.yearData.length === 2 ? moduleData?.yearData[1] : {};
  return {
    firstYear,
    secondYear,
  };
};
